import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import CollapsibleTitle from './CollapsibleTitle';
import CollapsibleContent from './CollapsibleContent';

class Collapsible extends PureComponent {

  state = {
    active: false,
  }

  componentDidMount() {

    this.setState({active: this.props.expanded});
  }

  toggleCollapse = () => {
    const { active } = this.state;

    this.props.onToggle(!active);

    this.setState({
      active: !active,
    });
  }

  render() {

    const { classList, expanded, animated } = this.props;
    const cssClasses = [];
    const collapsibleState = expanded ? 'expanded' : 'collapsed';
    const collapsibleClass = animated ? `animate-${collapsibleState}` : collapsibleState;

    cssClasses.push(collapsibleClass);

    return (
      <div className={'rct-cllpsbl ' + classList.join(' ')}>
        <CollapsibleTitle title={this.props.title} />
        { this.props.expanded &&
          <CollapsibleContent classList={[cssClasses]}>
            {this.props.children}
          </CollapsibleContent>
        }
      </div>
    );
  }
}

Collapsible.propTypes = {
  classList: PropTypes.array,
  onToggle: PropTypes.func,
  expanded: PropTypes.bool,
  customToggle: PropTypes.func,
};

Collapsible.defaultProps = {
  classList: [],
  expanded: false,
  onToggle: () => {},
};

export default Collapsible;



// WEBPACK FOOTER //
// ./js/components/global/collapsible/Collapsible.js